import { useEffect, useState } from "preact/hooks";

export function LeadIn({ onDone }: { onDone: () => void }) {
  const [n, setN] = useState(3);

  useEffect(() => {
    if (n <= 0) {
      onDone();
      return;
    }
    const t = setTimeout(() => setN((x) => x - 1), 800);
    return () => clearTimeout(t);
  }, [n]);

  return (
    <div class="stage stage-leadin">
      <p class="stage-kicker">Get ready</p>
      <div class="display mono stage-hero">{n > 0 ? n : "GO"}</div>
    </div>
  );
}
